import type { Period } from '@/entities/types';
import { ContextPane } from './ContextPane';
import { MainPlan } from './MainPlan';
import { SidePane } from './SidePane';

interface PlanViewProps {
  className?: string;
  period: Period;
  targetStartAt: Date;
  targetStartAtLocal: string;
}

export function PlanView({
  className,
  period,
  targetStartAt,
  targetStartAtLocal,
}: PlanViewProps) {
  return (
    <div className={`flex h-full min-h-0 ${className ?? ''}`}>
      <div className="hidden max-w-[33.333%] min-w-0 flex-1 md:flex">
        <SidePane
          className="max-w-[400px]"
          period={period}
          targetStartAt={targetStartAt}
        />
      </div>
      <MainPlan
        className="m-0 w-full max-w-[650px] overflow-y-scroll px-5 py-7 md:mx-5 md:w-1/2 md:px-10 md:py-10"
        period={period}
        targetStartAt={targetStartAt}
        targetStartAtLocal={targetStartAtLocal}
      />
      <ContextPane
        className="hidden h-full max-w-[500px] min-w-0 flex-1 overflow-y-scroll p-4 md:block"
        period={period}
        targetStartAt={targetStartAt}
      />
    </div>
  );
}
